import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBDateField, CopyButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { GoalDropDown } from './GoalDropDown';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';

class PatientCareCenterNoteGoalsGoalDetailsFuncPN extends React.Component {

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    copyClof() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF', this.props.goal.GOCLOFPREV);
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGPNO', this.props.goal.GOGPNOPREV);
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOGOALLEVEL &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOGOALLEVEL)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGOALLEVEL');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOPLOF &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOPLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOPLOF');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOCLOF &&
            !Object.keys(this.props.clofGoalLevels).map(key => { return this.props.clofGoalLevels[key].id }).includes(prevProps.goal.GOCLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_row}>
                <span className={styles.goal_detail_col1}>
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        </span>
                        {/* Activity */}
                        <div className={styles.goal_detail_col2_pd}>
                            <GoalDropDown
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                isFunctional={true}
                                includeCustom={false}
                                disabled={this.props.goalMet}
                                className={styles.goal_dropdown}
                            />
                        </div>
                        {/* PLOF */}
                        <div className={styles.goal_detail_col3_pd}>
                            <DBDropDown
                                className={styles.goal_level_dropdown}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOPLOF'
                                disabled={this.props.goalMet}
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* CLOF */}
                        <div className={styles.goal_detail_col4_pd}>
                            <DBDropDown
                                className={styles.goal_level_dropdown}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOCLOF'
                                disabled={this.props.goalMet}
                                customOptions={this.props.clofGoalLevels}
                                placeholder='Current Ability'
                            />
                        </div>
                        <div className={styles.goal_detail_copy_col}>
                            <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyClof()} />
                        </div>
						
                        {/* GOAL */}
                        <div className={styles.goal_detail_col5_pd}>
                            <DBDropDown
                                className={styles.goal_dropdown}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOGOALLEVEL'
                                disabled={this.props.goalMet}
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* DATE */}
                        <div className={styles.goal_detail_col6_pd}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODATE'
                                disabled={this.props.goalMet}
                                customMsg='The goal date cannot be in the past.'
                                minDate={getDateMMDDYYYY(new Date())}
                                defaultdate = {this.props.days}
                            />
                        </div>
                        {/* PROGRESS */}
						<div className={styles.goal_detail_col7_pd}>
						<DBDropDown
                            className={styles.goal_level_dropdown}
							noteId={this.props.noteId}
							entity='PTGOALS'
							entityKeyColumn='GONO'
							entityKeyValue={this.props.goal.GONO}
							field='GOGPNO'
							masterEntity='PTMASTERGOALPROGRESS'
							masterEntityKeyColumn='GPNO'
							masterEntitySort='GPORDER'
							masterEntityDisplay='GPNAME'
							onChange={() => this.goalValueChanged()}
						/>
						    
					    </div>
                        <div className={styles.goal_detail_copy_col_extend}>
                        <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                        </div>
                    </div>
                    <div className={styles.goal_detail_row}>
                        <div className={styles.goal_detail_col8_pd}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOOBJECTIVE'
                                className={styles.text_field}
                                disabled={this.props.goalMet}
                                placeholder='Describe how the patient is performing the activity today.'
                            />
                        </div>
                    </div>
            </PatientCareCenterNoteNavAnchor>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;
    let days = ownprops.days;
    let goalMet = false; 

    if (state.entities.notes.PTGOALS[ownprops.id].GOGPNO === 11)
    {
        goalMet = true;   
    }

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            return clofGoalLevels[key].clofOnly === false;
        })
        .map(key => {
            return clofGoalLevels[key];
        });

    let clofPrev = goal.GOCLOFPREV ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOCLOFPREV].GLNAME : undefined;
    let progressPrev = goal.GOGPNOPREV ? state.entities.masterData.PTMASTERGOALPROGRESS[goal.GOGPNOPREV].GPNAME : undefined;

    return {
        noteId,
        noteType,
        pk,
        goal,
        clofGoalLevels,
        goalLevels,
        goalsUpdated,
        clofPrev,
        progressPrev,
        isPrevGoal: goal.GOGONO ? true : false,
        days,
        goalMet
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsFuncPN = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsFuncPN);
export { connectedPatientCareCenterNoteGoalsGoalDetailsFuncPN as PatientCareCenterNoteGoalsGoalDetailsFuncPN };

